import type { JSTAppSessionInfo } from '../types/TareBridge';

import { getTareBridge } from './getTareBridge';
import { callPromiseSafely } from '../../util/callPromiseSafely';

/**
 * Gets the app session info from the native module.
 */
export function getAppSessionInfo(): Promise<JSTAppSessionInfo | null> {
    return callPromiseSafely(getTareBridge()?.getAppSessionInfo);
}

/**
 * Synchronous call to get the app session info from the native module.
 */
export function getAppSessionInfoSync(): JSTAppSessionInfo | null {
    return getTareBridge()?.getAppSessionInfoSync?.() ?? null;
}